import React from "react";

import { Icon } from "../icon/Icon";

import "./ShowToggle.scss";

export const ShowToggle = (props) => {
  return (
    <span className="show-toggle" data-testid={"show-toggle"}>
      <Icon icon={`fa-light fa-angle-${props.isOpen ? "up" : "down"}`} />
    </span>
  );
};
